import React from 'react';
import { USER_ROLES } from '../../../../types';

export const UserRoleLabel: React.FC<{ userRole: USER_ROLES }> = ({ userRole }) => (
    <div data-testid='user-role-label' className={`UserRole UserRole__${userRole}`}>
        {userRole}
    </div>
);